import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locale/en/en.json';
import pl from './locale/pl/pl.json';
import nl from './locale/nl/nl.json';
import ghgEn from './locale/en/ghg.json';
import ghgPl from './locale/pl/ghg.json';
import ghgNl from './locale/nl/ghg.json';
import esgEn from './locale/en/esg.json';
import esgPl from './locale/pl/esg.json';
import esgNl from './locale/nl/esg.json';
import superadminEn from './locale/en/superadmin.json';
import superadminPl from './locale/pl/superadmin.json';
import registrationEn from './locale/en/registration.json';
import registrationPl from './locale/pl/registration.json';
import superdashboardGhgPl from './locale/pl/superdashboardGhg.json';
import superdashboardGhgEn from './locale/en/superdashboardGhg.json';
import registrationBnpPl from './locale/pl/registration_bnp.json';
import registrationRabenPl from './locale/pl/registration_raben.json';
import registrationRabenEn from './locale/en/registration_raben.json';
import registrationRabenNl from './locale/nl/registration_raben.json';
import cs from './locale/cs/cs.json';
import csEsg from './locale/cs/esg.json';
import csGhg from './locale/cs/ghg.json';
import csRegistrationRaben from './locale/cs/registration_raben.json';
import de from './locale/de/de.json';
import deEsg from './locale/de/esg.json';
import deGhg from './locale/de/ghg.json';
import deRegistrationRaben from './locale/de/registration_raben.json';
import deRegistration from './locale/de/registration.json';
import deSuperadmin from './locale/de/superadmin.json';
import deSuperdashboardGhg from './locale/de/superdashboardGhg.json';
import ro from './locale/ro/ro.json';
import roEsg from './locale/ro/esg.json';
import roGhg from './locale/ro/ghg.json';
import roSuperadmin from './locale/ro/superadmin.json';
import roSuperdashboardGhg from './locale/ro/superdashboardGhg.json';
import roRegistration from './locale/ro/registration.json';
import roRegistrationRaben from './locale/ro/registration_raben.json';
import roCbam from './locale/ro/cbam.json';
import cbam from './locale/en/cbam.json';
import { LocalStorageKeys } from './common/constants';

const resources = {
  en: {
    translation: {
      ...en,
      esg: esgEn,
      ghg: ghgEn,
      superdashboardGhg: superdashboardGhgEn,
      superadmin: superadminEn,
      registration: registrationEn,
      registration_bnp: registrationBnpPl, // the same for both languages
      registration_raben: registrationRabenEn,
      cbam, // the same for both languages
    },
  },
  pl: {
    translation: {
      ...pl,
      esg: esgPl,
      ghg: ghgPl,
      superdashboardGhg: superdashboardGhgPl,
      superadmin: superadminPl,
      registration: registrationPl,
      registration_bnp: registrationBnpPl,
      registration_raben: registrationRabenPl,
      cbam,
    },
  },
  nl: {
    translation: {
      ...nl,
      esg: esgNl,
      ghg: ghgNl,
      registration_raben: registrationRabenNl,
    },
  },
  cs: {
    translation: {
      ...cs,
      esg: csEsg,
      ghg: csGhg,
      registration_raben: csRegistrationRaben,
    },
  },
  de: {
    translation: {
      ...de,
      esg: deEsg,
      ghg: deGhg,
      // Settings and the group sidebar were English for German users: these
      // namespaces had no de file and fell back to `fallbackLng: 'en'`.
      superdashboardGhg: deSuperdashboardGhg,
      superadmin: deSuperadmin,
      registration: deRegistration,
      registration_raben: deRegistrationRaben,
    },
  },
  ro: {
    translation: {
      // Built from the Raben RO workbook by
      // scripts/build_ro_locale_from_xlsx.py; every en key has a ro value
      // (roLocaleParity.test.ts), so the en fallback is never reached.
      ...ro,
      esg: roEsg,
      ghg: roGhg,
      superdashboardGhg: roSuperdashboardGhg,
      superadmin: roSuperadmin,
      registration: roRegistration,
      registration_raben: roRegistrationRaben,
      cbam: roCbam,
    },
  },
};

export const SUPPORTED_LANGUAGES = Object.keys(resources);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    resources,
    supportedLngs: Object.keys(resources),
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: LocalStorageKeys.LOCAL_LANGUAGE,
      convertDetectedLanguage(lng: string) {
        return lng.split('-')[0];
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
